import { render, staticRenderFns } from "./onSubFormRowDelete-editor.vue?vue&type=template&id=6904ac3c&scoped=true&"
import script from "./onSubFormRowDelete-editor.vue?vue&type=script&lang=js&"
export * from "./onSubFormRowDelete-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6904ac3c",
  null
  
)

export default component.exports